export const getAllProducts = (state) => state.products.data;

export const productsLoading = (state) => state.products.isLoading;